import { CATEGORIES_SERVICE } from "@/services/categories.service.js";
import router from '@/router/index';

const state = { listOutput: {}, categoryOutput: false, processTask: false, removeTask: false };

const actions = {
    getList({ dispatch, commit }, params) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        CATEGORIES_SERVICE.list(params)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    editCategory({ dispatch, commit }, category) {
        dispatch('alert/clear', null, { root: true });
        commit('editRequest');

        CATEGORIES_SERVICE.edit(category)
            .then(
                output => {
                    commit('editSuccess', output);
                },
                error => {
                    commit('editFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    addCategory({ dispatch, commit }, category) {
        dispatch('alert/clear', null, { root: true });
        commit('addRequest');
        
        CATEGORIES_SERVICE.add(category)
            .then(
                output => {
                    commit('addSuccess', output);
                },
                error => {
                    commit('addFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getCategory({ dispatch, commit }, categoryId) {
        dispatch('alert/clear', null, { root: true });
        commit('getRequest');

        CATEGORIES_SERVICE.get(categoryId)
            .then(
                output => {
                    commit('getSuccess', output);
                },
                error => {
                    commit('getFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    removeCategory({ dispatch, commit }, categoryId) {
        dispatch('alert/clear', null, { root: true });
        commit('removeRequest');

        CATEGORIES_SERVICE.remove(categoryId)
            .then(
                output => {
                    commit('removeSuccess');
                },
                error => {
                    commit('removeFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    reset({ dispatch, commit }){
        commit('resetRequest');
    }
};

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = [];
    },
    /* Add */
    addRequest(state) {
        state.processTask = null;
    },
    addSuccess(state) {
        state.processTask = true;
    },
    addFailure(state) {
        state.processTask = false;

    },
    /* Edit */
    editRequest(state) {
        state.processTask = null;
    },
    editSuccess(state) {
        state.processTask = true;
    },
    editFailure(state) {
        state.processTask = false;
    },
    /* Get */
    getRequest(state) {
        state.categoryOutput = null;
    },
    getSuccess(state, output) {
        state.categoryOutput = output;
    },
    getFailure(state) {
        state.categoryOutput = false;
    },
    /* Remove */
    removeRequest(state) {
        state.removeTask = undefined;
    },
    removeSuccess(state) {
        state.removeTask = true;
    },
    removeFailure(state) {
        state.removeTask = false;
    },
    /* Reset */
    resetRequest(state) {
        state.listOutput = {};
        state.categoryOutput = false;
        state.processTask = false;
        state.removeTask = false
    }
};

export const categories = {
    namespaced: true,
    state,
    actions,
    mutations
};